import { NeoReport, Report } from "@singularsystems/neo-reporting";
import DividendLetterCriteria from "./DividendLetterCriteria";

@NeoReport("DividendLetter", { hidden: true })
export default class DividendLetterReport extends Report<DividendLetterCriteria> {

    constructor() {
        super(DividendLetterCriteria);
    }

    public renderCriteria() {
        return <div>
        </div>;
    }
}